import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when a user is missing the authorization for an API call.
 */
export class MissingAuthError extends RESTError {}
